import { animatePulse } from "@/src/utils/animation.utils";
import React, { useEffect, useRef } from "react";
import { Animated, View } from "react-native";

const CommentSkeleton = () => {
  const opacity = useRef(new Animated.Value(0.3)).current;

  useEffect(() => {
    animatePulse(opacity);
  }, []);

  return (
    <Animated.View style={{ opacity }} className="flex-row items-start mb-4">
      {/* Avatar */}
      <View className="w-10 h-10 rounded-full bg-ash-3 mr-3" />

      {/* Text Content */}
      <View className="flex-1">
        <View className="h-3 w-24 bg-ash-3 rounded mb-2" />
        <View className="h-3 w-full bg-ash-3 rounded mb-1" />
        <View className="h-3 w-3/4 bg-ash-3 rounded" />
      </View>
    </Animated.View>
  );
};

export default CommentSkeleton;
